import { TrafficInfoResponse, TrafficInfoResponseAreaInfo } from '../traffic-info-types';
import { ReactComponent as AccordionInfo } from '../../../assets/icons/icon-accordion-info.svg';
import styles from './traffic-info-area-infos.module.scss';
import { useState } from 'react';
import { ButtonComponent } from '../../../components/controls/button/button';
import { TrafficInfoAreaModal } from './traffic-info-area-modal/traffic-info-area-modal';

export interface TrafficInfoAreaInfosProps {
  data: TrafficInfoResponse;
}

export const TrafficInfoAreaInfos = ({ data }: TrafficInfoAreaInfosProps): JSX.Element | null => {
  const [selectedInfo, setSelectedInfo] = useState<TrafficInfoResponseAreaInfo | null>(null);

  if (!data.areaInfos?.length) {
    return null;
  }

  return (
    <>
      <div className={styles.TrafficInfoAreaInfos}>
        {data.areaInfos?.map((areaInfo) => (
          <TrafficInfoAreaInfo key={areaInfo.id} info={areaInfo} onShow={(): void => setSelectedInfo(areaInfo)} />
        ))}
      </div>
      <TrafficInfoAreaModal
        open={selectedInfo !== null}
        info={selectedInfo ?? undefined}
        onClose={(): void => setSelectedInfo(null)}
      />
    </>
  );
};

const TrafficInfoAreaInfo = ({
  info,
  onShow,
}: {
  info: TrafficInfoResponseAreaInfo;
  onShow: () => void;
}): JSX.Element => {
  return (
    <div className={styles.TrafficInfoAreaInfo}>
      <div className={styles.TrafficInfoAreaInfoIcon}>
        <AccordionInfo />
      </div>
      <div className={styles.TrafficInfoAreaInfoTitle}>{info.title}</div>
      <div>
        <ButtonComponent color="secondary" small={false} content="Meldung anzeigen" onClick={onShow} />
      </div>
    </div>
  );
};
